/* eslint-disable @typescript-eslint/lines-between-class-members */

import { GSceneDesc } from "./scenes/scene";
import { GetVec2, GetVec3 } from "./core/types";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { GTime, MathGetVec2Length, MathVector2Normalize, MathVector3Normalize } from "./core/utils";

export class GCameraShakeController {
    static CachedCamPos = { x: 0.0, y: 0.0, z: 0.0 };

    static ShakeEventParam = 0.0;

    static bShakeEventRunning = false;

    static ShakeDuration = 0.1;

    static RandAmplitudeXYZ = { x: 0.0, y: 0.0, z: 0.0 };

    static ShakeStrength = 1.0;

    static ShakeCameraFast(strength = 1.0) {
        if (!GCameraShakeController.bShakeEventRunning) {
            this.ShakeStrength = strength * 4.0;

            this.bShakeEventRunning = true;
            this.ShakeEventParam = 0.0;

            const rand = 0.25 + Math.random() * 0.75;
            this.RandAmplitudeXYZ.x = rand;
            this.RandAmplitudeXYZ.y = 1.0 - rand;
            this.RandAmplitudeXYZ.z = 0.25 + Math.random() * 0.4;
            //this.RandAmplitudeXYZ.z = 0.5;

            if (Math.random() > 0.5) {
                this.RandAmplitudeXYZ.x *= -1.0;
            }
            if (Math.random() > 0.5) {
                this.RandAmplitudeXYZ.y *= -1.0;
            }

            this.CachedCamPos.x = GSceneDesc.Camera.Position.x;
            this.CachedCamPos.y = GSceneDesc.Camera.Position.y;
            this.CachedCamPos.z = GSceneDesc.Camera.Position.z;
        }
    }

    static OnUpdate() {
        if (this.bShakeEventRunning) {
            const shakeStrength = 0.05 * 0.5 * GCameraShakeController.ShakeStrength * this.RandAmplitudeXYZ.z;

            const shakeSpeed = 1.0;

            const xOffset =
                Math.sin(this.ShakeEventParam * 37.0 * shakeSpeed) * shakeStrength * this.RandAmplitudeXYZ.x;
            const yOffset =
                Math.sin(this.ShakeEventParam * 40.0 * shakeSpeed) * shakeStrength * this.RandAmplitudeXYZ.y;

            GSceneDesc.Camera.Position.x = this.CachedCamPos.x + xOffset;
            GSceneDesc.Camera.Position.y = this.CachedCamPos.y + yOffset;

            this.ShakeEventParam += GTime.Delta;

            if (this.ShakeEventParam > this.ShakeDuration) {
                this.bShakeEventRunning = false;
                GSceneDesc.Camera.Position.x = this.CachedCamPos.x;
                GSceneDesc.Camera.Position.y = this.CachedCamPos.y;
            }
        }
    }
}

export class GSpotlightShakeController {
    static CachedSpotlightPos = { x: 0.0, y: 0.0, z: 0.0 };
    static CachedSpotlightFocusPos = { x: 0.0, y: 0.0, z: 0.0 };

    static VelocityCur = GetVec3(0, 0, 0);
    static kMaxBounds = GetVec3(1, 1, 1.0);
    static DesiredFocusPos = GetVec3(0, 0, 0);

    static kConnectionConstraintStiffness = 10.0;

    static Init() {}

    static ShakeSpotlight(strength = 1.0) {
        //Apply random dir force
        const force = MathVector2Normalize(GetVec2(-1.0 + Math.random() * 2.0, Math.random() * 1.5));

        const dt = Math.min(1 / 60, GTime.Delta);

        strength *= 100.0;

        this.VelocityCur.x += force.x * strength * dt;
        this.VelocityCur.z += force.y * strength * dt;
    }

    static OnUpdate() {
        const curFocusPos = GSceneDesc.Spotlight.FocusPosition;

        const diff = GetVec2(
            this.CachedSpotlightFocusPos.x - curFocusPos.x,
            this.CachedSpotlightFocusPos.z - curFocusPos.z,
        );

        const curDist = MathGetVec2Length(diff) * this.kConnectionConstraintStiffness;
        const dir = MathVector2Normalize(diff);

        const dt = Math.min(1 / 60, GTime.Delta);

        this.VelocityCur.x += dir.x * curDist * dt;
        this.VelocityCur.z += dir.y * curDist * dt;

        //Damping
        this.VelocityCur.x = this.VelocityCur.x * 0.99;
        this.VelocityCur.y = this.VelocityCur.y * 0.99;
        this.VelocityCur.z = this.VelocityCur.z * 0.99;

        //Integrate
        const focusOffsetScale = 2.0;
        curFocusPos.x = curFocusPos.x + this.VelocityCur.x * focusOffsetScale * dt;
        curFocusPos.z = curFocusPos.z + this.VelocityCur.z * focusOffsetScale * dt;

        const newDiff = GetVec2(
            this.CachedSpotlightFocusPos.x - curFocusPos.x,
            this.CachedSpotlightFocusPos.z - curFocusPos.z,
        );

        const posOffset = MathVector3Normalize(GetVec3(newDiff.x, -1, newDiff.y));
        const posOffsetScale = 0.5;
        GSceneDesc.Spotlight.Position.x = this.CachedSpotlightPos.x - posOffset.x * posOffsetScale;
        GSceneDesc.Spotlight.Position.y = this.CachedSpotlightPos.y + posOffsetScale + posOffset.y * posOffsetScale;
        GSceneDesc.Spotlight.Position.z = this.CachedSpotlightPos.z - posOffset.z * posOffsetScale;
    }
}
